import { useTranslations } from 'next-intl'

export const BasePlaceholder = () => {
	const t = useTranslations()
	const placeholderDescription = t(
		'generator__phone_preview__placeholder_description',
	)

	return (
		<svg
			width={220}
			height={264}
			viewBox="30 156 220 264"
			className="absolute left-1/2 top-[148px] -translate-x-1/2 overflow-visible"
			xmlns="http://www.w3.org/2000/svg"
		>
			<defs>
				<filter
					id="filter0_d_188_3879"
					x={49.967}
					y={155}
					width={180.065}
					height={180.065}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={1} />
					<feGaussianBlur stdDeviation={4} />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix values="0 0 0 0 0.24705 0 0 0 0 0.281923 0 0 0 0 0.405566 0 0 0 0.16 0" />
					<feBlend
						in2="BackgroundImageFix"
						result="effect1_dropShadow_188_3879"
					/>
					<feBlend
						in="SourceGraphic"
						in2="effect1_dropShadow_188_3879"
						result="shape"
					/>
				</filter>
			</defs>
			<g>
				<g id="Group 19778">
					<g id="Group 3355" filter="url(#filter0_d_188_3879)">
						<g id="Group">
							<path
								id="Rectangle 2336"
								d="M211.905 162H68.095c-5.593 0-10.128 4.534-10.128 10.127v143.811c0 5.593 4.535 10.127 10.128 10.127h143.81c5.593 0 10.128-4.534 10.128-10.127V172.127c0-5.593-4.535-10.127-10.128-10.127"
								fill="#fff"
							/>
						</g>
						<g id="qr-code" opacity={0.8}>
							<g id="Group 1523">
								<g id="Group 1522" fill="#84868E">
									<path
										id="Path 2755"
										d="M118.22 186.062H82.03v36.191h36.19zm-7.238 28.953H89.268V193.3h21.714z"
									/>
									<path
										id="Path 2790"
										d="M97.136 201.168h6.713v6.713h-6.713z"
									/>
									<path
										id="Path 2756"
										d="M161.649 186.062v36.191h36.191v-36.191zm28.952 28.953h-21.714V193.3h21.714z"
									/>
									<path
										id="Path 2792"
										d="M176.136 201.168h6.713v6.713h-6.713z"
									/>
									<path
										id="Path 2757"
										d="M82.03 301.872h36.19v-36.19H82.03zm7.238-28.952h21.714v21.714H89.268z"
									/>
									<path
										id="Path 2791"
										d="M97.136 280.168h6.713v6.713h-6.713z"
									/>
									<g id="Group 1535">
										<path
											id="Rectangle 2235"
											d="M155.04 186.062h-15.105v6.714h15.105z"
										/>
										<path
											id="Path 2758"
											d="M139.935 215.015h7.238v-7.238h7.238v-7.239h-21.714V193.3h-7.239v14.477h14.477z"
										/>
										<path
											id="Rectangle 2236"
											d="M133.221 215.435h-7.553v6.713h7.553z"
										/>
										<path
											id="Path 2759"
											d="M154.411 222.252h-7.238v7.239h-21.715v7.238h28.953z"
										/>
										<path
											id="Path 2760"
											d="M89.268 251.205h7.238v-7.238h-7.238V229.49H82.03v28.953h7.238z"
										/>
										<path
											id="Rectangle 2237"
											d="M103.849 229.701h-6.714v7.552h6.714z"
										/>
										<path
											id="Path 2761"
											d="M123.458 258.443h14.477v-7.238h-7.238v-7.238H116.22V229.49h-7.238v14.477h-5.238v14.476h5.238v-7.238h14.476z"
										/>
										<path
											id="Rectangle 2238"
											d="M155.041 243.967h-8.393v15.106h8.393z"
										/>
										<path
											id="Path 2762"
											d="M147.173 265.81h-21.715v7.238h14.477v21.586h-14.477v7.238h21.715v-7.238h14.476v-7.238h-14.476z"
										/>
										<path
											id="Rectangle 2239"
											d="M133.221 280.053h-7.553v7.552h7.553z"
										/>
										<path
											id="Rectangle 2240"
											d="M161.754 265.786h-6.714v14.267h6.714z"
										/>
										<path
											id="Path 2763"
											d="M190.602 280.158h-21.715v21.714h7.238v-14.476h14.477z"
										/>
										<path
											id="Rectangle 2241"
											d="M197.84 295.157h-14.266v6.714h14.266z"
										/>
										<path
											id="Rectangle 2242"
											d="M197.839 265.786h-6.713v7.553h6.713z"
										/>
										<path
											id="Path 2764"
											d="M168.887 272.92h7.238v-21.715h-23.426v7.238h16.188z"
										/>
										<path
											id="Path 2765"
											d="M180.899 236.81h-8.4v-7h-8.4v7h-8.4v7h33.6v-7h8.4v-7h-16.8z"
										/>
										<path
											id="Rectangle 2243"
											d="M197.84 250.681h-14.266v8.392h14.266z"
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
					<path
						id="Rectangle 4283"
						fill="#fff"
						d="M112.699 226.81h55v33h-55z"
					/>
					<g id="Frame 56216" opacity={0.8}>
						<text
							id="LOGO"
							fill="#84868E"
							xmlSpace="preserve"
							style={{
								whiteSpace: 'pre',
							}}
							fontFamily="var(--font-heading)"
							fontSize={14}
							fontWeight={600}
							letterSpacing="0em"
						>
							<tspan x={121.133} y={249.295}>
								LOGO
							</tspan>
						</text>
					</g>
				</g>
				<foreignObject
					xmlSpace="preserve"
					x={30}
					y={358}
					width={220}
					height={60}
					className="overflow-visible"
				>
					<p className="type-body-medium w-full text-center font-body text-grey word-break-fix">
						{placeholderDescription}
					</p>
				</foreignObject>
			</g>
		</svg>
	)
}
